"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { useSession } from "@/lib/auth/auth-client";

/**
 * PostHog User Identification
 *
 * Links all PostHog events (pageviews, errors, session replays) to the
 * authenticated Better Auth user via Convex session.
 *
 * Uses the same useSession() hook as CartMergeHandler.tsx and ShopHeader.tsx.
 * Session shape: { data: { user: { id, email, name } } }
 *
 * MUST be rendered inside <ConvexClientProvider> because useSession()
 * depends on ConvexBetterAuthProvider context.
 */
export function PostHogIdentify() {
  const { data: session, isPending } = useSession();

  useEffect(() => {
    // Wait until auth state is resolved before doing anything
    if (isPending) return;

    if (session?.user) {
      // Identify the authenticated user so errors, replays, and events
      // are all linked to the same person profile in PostHog.
      posthog.identify(session.user.id, {
        email: session.user.email,
        name: session.user.name,
      });
    } else {
      // User is not signed in — reset PostHog to anonymous state.
      // This handles sign-outs correctly.
      posthog.reset();
    }
  }, [session, isPending]);

  // Renders nothing — purely a side-effect component
  return null;
}
